import type { CoreApiSchemas } from "@/services/core-api/types"
import { getDisplayValue } from "@/utils/value"

type FlowDirection = CoreApiSchemas["FlowDirection"]

export const FLOW_DIRECTION_VALUE_KEYS = {
  export: "fields.flowDirection.value.export",
  import: "fields.flowDirection.value.import",
} as const satisfies Record<FlowDirection, string>

export type FlowDirectionLabels = Record<FlowDirection, string>

export const formatFlowDirection = (
  value: string | null | undefined,
  labels: FlowDirectionLabels
): string => {
  if (value === "export" || value === "import") {
    return labels[value]
  }

  return getDisplayValue(value)
}
